import { createContext } from 'react';

export type MBConnectionStatus = 'online' | 'offline' | 'unknown';

export const ConnectionContext = createContext<MBConnectionStatus>('unknown');
